import * as React from 'react';

const useField = (
  defaultField: string
): [
  string,
  string,
  (value: string) => void,
  (error: string) => void,
  () => void,
] => {
  const [field, setField] = React.useState(defaultField);
  const [error, setError] = React.useState('');

  const onChangeField = React.useCallback<(value: string) => void>(
    (newField) => {
      setField(newField);
    },
    []
  );

  const reset = React.useCallback(() => {
    setError('');
    setField(defaultField);
  }, [defaultField]);

  return [field, error, onChangeField, setError, reset];
};

export default useField;
